import { render } from "./comment-card.vue?vue&type=template&id=0ff4f46e&ts=true"
import script from "./comment-card.vue?vue&type=script&lang=ts"
export * from "./comment-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__